import React from "react";

const GramsevakPage = () => {
  const gramPanchayat = {
    name: "गट ग्रामपंचायत सावंगी-घोगली",
    taluka: "कळमेश्वर",
    district: "नागपूर",
    pincode: "441501",
    area: "-- हेक्टर",
    contact: "+919765016588",
    email: "savangi-ghogali.grampanchayt@maharashtra.gov.in",
    website: "gpsavangi-ghogali.in",
  };

  const gramsevak = {
    name: "कु. हर्षा विनायकराव चरपे",
    designation: "ग्रामपंचायत अधिकारी",
    currentPosting: "गट ग्रामपंचायत सावंगी-घोगली",
    photo: `${process.env.PUBLIC_URL}/images/sachiv.jpg`,
  };

  const logo = `${process.env.PUBLIC_URL}/images/mh_logo.png`;
  const gpLogo = `${process.env.PUBLIC_URL}/images/gplogo.jpg`;

  return (
    <div style={styles.container}>
      {/* ===== सरकारी हेडर ===== */}
      <header style={styles.govHeader}>
        <img src={logo} alt="Maharashtra Logo" style={styles.emblemImg} />
        <div style={styles.govTitle}>
          <h1 style={styles.govName}>महाराष्ट्र शासन</h1>
          <h2 style={styles.dept}>ग्रामविकास विभाग | जिल्हा परिषद नागपूर</h2>
        </div>
      </header>

      {/* ===== मुख्य ग्रामपंचायत हेडर ===== */}
      <header style={styles.mainHeader}>
        <img src={gpLogo} alt="Gram Panchayat Logo" style={styles.gpLogo} />
        <div style={styles.title}>
          <h1 style={styles.gpName}>{gramPanchayat.name}</h1>
          <p style={styles.gpInfo}>
            तालुका: {gramPanchayat.taluka} | जिल्हा: {gramPanchayat.district} | पिनकोड:{" "}
            {gramPanchayat.pincode}
          </p>
        </div>
      </header>

      {/* ===== ग्रामसेवक परिचय ===== */}
      <section style={styles.introCard}>
        <h2 style={styles.cardTitle}>ग्रामपंचायत अधिकारी</h2>
        <div style={styles.profileBox}>
          <img src={gramsevak.photo} alt="Gramsevak" style={styles.bigPhoto} />
          <div style={styles.profileText}>
            <p><b>नाव :</b> {gramsevak.name}</p>
            <p><b>पद :</b> {gramsevak.designation}</p>
            <p><b>मोबाईल :</b> 9765016588</p>
            <p><b>सध्याची पोस्टिंग :</b> {gramsevak.currentPosting}</p>
          </div>
        </div>

        <p style={styles.para}>
          आम्ही ग्रामपंचायतीचे <b> ग्रामपंचायत अधिकारी</b> म्हणून कार्यरत आहोत.
          ग्रामपंचायत अधिकारी हे पद महाराष्ट्र ग्रामपंचायत अधिनियम, १९५८ नुसार स्थापित केले गेले असून,
          आम्ही ग्रामपंचायतीचे पदसिद्ध सचिव आणि प्रशासकीय प्रमुख म्हणून जबाबदारी सांभाळतो.
        </p>
      </section>

      {/* ===== ग्रामपंचायत माहिती ===== */}
      <section style={styles.card}>
        <h2 style={styles.cardTitle}>ग्रामपंचायत माहिती</h2>
        <div style={styles.infoGrid}>
          <div style={styles.infoRow}><span style={styles.infoLabel}>क्षेत्रफळ</span><span style={styles.infoValue}>{gramPanchayat.area}</span></div>
          <div style={styles.infoRow}><span style={styles.infoLabel}>संपर्क</span><span style={styles.infoValue}>{gramPanchayat.contact}</span></div>
          <div style={styles.infoRow}><span style={styles.infoLabel}>ई-मेल</span><span style={styles.infoValue}>{gramPanchayat.email}</span></div>
          <div style={styles.infoRow}>
            <span style={styles.infoLabel}>वेबसाइट</span>
            <a href={`https://${gramPanchayat.website}`} target="_blank" rel="noopener noreferrer" style={styles.link}>
              {gramPanchayat.website}
            </a>
          </div>
        </div>
      </section>

      {/* ===== मुख्य कर्तव्ये ===== */}
      <section style={styles.card}>
        <h2 style={styles.cardTitle}>मुख्य कर्तव्ये</h2>
        <ul style={styles.dutyList}>
          <li>ग्रामसभेचे आयोजन व कार्यवृत्त तयार करणे</li>
          <li>कर वसुली, पाणीपट्टी, स्वच्छता शुल्क</li>
          <li>मनरेगा, स्वच्छ भारत, PMAY योजनांची अंमलबजावणी</li>
          <li>जन्म-मृत्यू, लग्न नोंदणी</li>
          <li>ग्रामपंचायत अभिलेख (नमुना १ ते ३३) ठेवणे</li>
        </ul>
      </section>

      {/* ===== फूटर ===== */}
      <footer style={styles.footer}>
        <div style={styles.footerLine}></div>
        <p style={styles.footerText}>
          ही सेवा पुस्तिका <strong>महाराष्ट्र नागरी सेवा (सेवा पुस्तिका) नियम १९८१</strong> नुसार तयार केली आहे.
        </p>
        <p style={styles.copyright}>
          © २०२५ जिल्हा परिषद नागपूर | ग्रामविकास विभाग
        </p>
      </footer>
    </div>
  );
};

/* ============================
       INTERNAL CSS (Styles)
============================= */

const styles = {
  container: {
    fontFamily: "'Noto Sans Devanagari', sans-serif",
    maxWidth: "950px",
    margin: "20px auto",
    padding: "30px",
    background: "#fefefe",
    borderRadius: "16px",
    border: "3px solid #1b5e20",
    boxShadow: "0 10px 25px rgba(0,0,0,0.12)",
  },

  /* ---- सरकारी विभाग ---- */
  govHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, #ff9933, #ffffff, #138808)",
    padding: "16px",
    borderRadius: "14px",
    color: "#000",
    marginBottom: "20px",
  },
  emblemImg: {
    width: "70px",
    height: "70px",
    marginRight: "15px",
    borderRadius: "50%",
    border: "2px solid #333",
  },
  govName: { margin: 0, fontSize: "22px", fontWeight: "bold" },
  dept: { margin: 0, fontSize: "15px", fontWeight: "600" },

  /* ---- ग्रामपंचायत हेडर ---- */
  mainHeader: {
    display: "flex",
    alignItems: "center",
    background: "#e8f5e9",
    padding: "20px",
    borderRadius: "14px",
    border: "2px solid #81c784",
    marginBottom: "30px",
  },
  gpLogo: {
    width: "85px",
    height: "85px",
    borderRadius: "50%",
    marginRight: "20px",
    border: "2px solid #2e7d32",
  },
  gpName: { margin: 0, fontSize: "28px", color: "#1b5e20", fontWeight: "bold" },
  gpInfo: { margin: 0, fontSize: "17px", color: "#2e7d32", fontWeight: "600" },

  /* ---- ग्रामसेवक प्रोफाइल ---- */
  introCard: {
    background: "#ffffff",
    padding: "25px",
    borderRadius: "14px",
    border: "1px solid #c8e6c9",
    marginBottom: "25px",
    boxShadow: "0 6px 14px rgba(0,0,0,0.08)",
  },
  profileBox: {
    display: "flex",
    alignItems: "center",
    marginBottom: "20px",
  },
  bigPhoto: {
    width: "130px",
    height: "150px",
    borderRadius: "10px",
    border: "2px solid #81c784",
    marginRight: "20px",
  },
  profileText: { fontSize: "16px" },
  para: { fontSize: "16px", lineHeight: "1.7" },

  /* ---- कार्ड ---- */
  card: {
    background: "white",
    padding: "25px",
    borderRadius: "14px",
    border: "1px solid #a5d6a7",
    marginBottom: "25px",
  },
  cardTitle: {
    marginBottom: "15px",
    fontSize: "22px",
    color: "#1b5e20",
    borderBottom: "3px solid #81c784",
    paddingBottom: "6px",
  },

  infoGrid: { display: "grid", gap: "12px" },
  infoRow: {
    display: "flex",
    borderRadius: "8px",
    overflow: "hidden",
    border: "1px solid #c5e1a5",
  },
  infoLabel: {
    background: "#81c784",
    color: "#fff",
    padding: "12px",
    width: "40%",
    fontWeight: "bold",
  },
  infoValue: { padding: "12px", background: "#f9fbe7", flex: 1 },
  link: { padding: "12px", color: "#2e7d32", fontWeight: 600 },

  dutyList: { paddingLeft: "20px", lineHeight: "1.9", fontSize: "16px" },

  /* ---- फूटर ---- */
  footer: { textAlign: "center", marginTop: "25px" },
  footerLine: {
    height: "2px",
    background: "linear-gradient(to right, transparent, #81c784, transparent)",
    marginBottom: "10px",
  },
  footerText: { color: "#2e7d32", fontSize: "15px" },
  copyright: { fontSize: "13px", color: "#666" },
};

export default GramsevakPage;
